export default function Model<T>() {
    class Model {
        static get create(): <R extends T>(data: R) => R  {
            /* @ts-ignore-next-line */
            return <R extends T>(data: R) => new this(data)
        }

        /** @todo its a hack. avoid using it */
        private makeAttrs(data: any){
            for (const key in data) {
                if (data.hasOwnProperty(key)) {
                    /* @ts-ignore-next-line */
                    this[key] = data[key];
                }
            }
        }
    }

    return Model
}